import { Component, Input, OnInit } from '@angular/core';
import { BrokerMappingService } from '../broker-mapping.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ButtonModule } from 'primeng/button';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { DrawerModule } from 'primeng/drawer';

@Component({
    selector: 'app-view-broker-mapping',
    templateUrl: './view-broker-mapping.component.html',
    styleUrls: ['./view-broker-mapping.component.scss'],
    imports: [CommonModule, TableModule, ButtonModule, FormsModule,
        MatProgressSpinnerModule, MatTooltipModule, ConfirmDialogModule, DrawerModule
    ]
})
export class ViewBrokerMappingComponent implements OnInit {
  @Input('selectedRow') selectedRow: any;
  @Input('columns') columns: any;
  constructor(public brokerMappingService: BrokerMappingService,) { }

  ngOnInit() {
  }
  onClose() {
    this.brokerMappingService.isView = false;
  }
  ngOnDestroy() {
    this.brokerMappingService.isView = false;
  }

}
